<template>
	<div id="login" class="login">
		<div class="user-login-5">
			<div class="row bs-reset">
				<div class="col-md-6 bs-reset mt-login-5-bsfix">
                    <div class="login-bg">
                        <img class="login-logo" src="../assets/img/app/logo.png" />
                    </div>
                </div>
                <div class="col-md-6 login-container bs-reset mt-login-5-bsfix">
                	<div class="login-content" v-if="!forgotPassword">
                		<h1>UNOapp Login</h1>
                		<form class="login-form" @submit.prevent="login($event)" novalidate>
                            <div class="alert alert-danger" v-if="errorMessage.length">
                                <button type="button" class="close" data-close="alert" @click="clearError()"></button>
                                <span>{{ errorMessage }}</span>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <input class="form-control form-control-solid placeholder-no-fix form-group" type="email" autocomplete="off" placeholder="Email" name="email" v-model="user.email"/>
                               	</div>
                                <div class="col-sm-6">
                                    <input class="form-control form-control-solid placeholder-no-fix form-group" type="password" autocomplete="off" placeholder="Password" name="password"  v-model="user.password"/> 
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 text-right">
                                	<div class="forgot-password">
                                        <a id="forget-password" class="forget-password" @click="showForgotPassword()">Forgot Password?</a>
                                    </div>
                                    <button class="btn green" type="submit">Login</button>
                                </div>
                            </div>
                        </form>
                	</div>
                	<div class="login-content" v-if="forgotPassword">
                		<h3 class="font-green">Forgot Password?</h3>
                        <p> Enter your e-mail address below to reset your password. </p>
                		<form class="forget-form" @submit.prevent="submitForgotPassword($event)" v-if="!emailSent" novalidate>
                            <div class="alert alert-danger alert-email-error" v-if="errorMessage.length">
                			    <button class="close" data-close="alert" @click="clearError()"></button>
                			    <span>{{ errorMessage }}</span>
                			</div>
                            <div class="form-group">
                                <input class="form-control placeholder-no-fix form-group" type="email" autocomplete="off" placeholder="Email" name="email" v-model="user.email"/> 
                            </div>
                            <div class="form-actions">
                                <button type="button" id="back-btn" class="btn green btn-outline" @click="goBack()">Back</button>
                                <button type="submit" class="btn btn-success uppercase pull-right">Submit</button>
                            </div>
                        </form>
                        <div class="login-content" v-if="emailSent">
    						<h1>An email has been sent to you with a link to reset your password! Please make sure you check your spam folder.</h1>
                            <button class="btn green" @click="goBack()">Login</button>
    					</div>
                	</div>
                </div>
			</div>
		</div>
		<modal :show.sync="showMobileAppPopup" effect="fade">
			<div slot="modal-header" class="modal-header text-center">
				<h4 class="modal-title">Hi!</h4>
			</div>
			<div slot="modal-body" class="modal-body">
				We recommend using our mobile app for {{ deviceType }}. The app can be downloaded from <a :href="appStoreDetails.url">{{ appStoreDetails.type }}</a>.
			</div>
			<div slot="modal-footer" class="modal-footer">
				<button type="button" class="btn btn-primary" @click="showMobileAppPopup = false">Okay</button>
			</div>
		</modal>
	</div>
</template>

<script>
const img1 = require('../assets/img/app/login/bg1.jpg')
const img2 = require('../assets/img/app/login/bg2.jpg')
const img3 = require('../assets/img/app/login/bg3.jpg')

/**
 * Login module is the login page for the application.
 * @class Login
 * @since 0.0.1
 */

import $ from 'jquery'
import GlobalFunctions from '../global'
import {BackgroundRotator} from '../assets/scripts/backgroundRotator'
import App from './App'
import Modal from './modules/Modal'
import Auth from '../controllers/Auth'
import { mapActions } from 'vuex'

/**
 * Set the timer for session length.
 * @var {integer}
 * @example Hours * Minutes * Seconds * 1000
 * @memberof Login
 */
const timer = 3 * 60 * 60 * 1000

/**
 * Set the timeout count for length of `I'm still here` modal.
 * @var {integer}
 * @example Minutes * Seconds * 1000
 * @memberof Login
 */
const timeoutCount = 3 * 60 * 1000

/**
 * Define the email pattern to check for valid emails.
 * @var {regex}
 * @memberof Login
 */
const emailPattern = /^.+@.+\..+$/

export default {
	name: 'login',
	data () {
		return {
			forgotPassword: false,
			user: {
				email: '',
				password: ''
			},
			errorMessage: '',
			emailSent: false,
			showMobileAppPopup: false,
			deviceType: '',
			appStoreDetails: {
				type: '',
				url: ''
			}
		}
	},
	/**
	 * Run on `created` to check whether or not the user is supposed to be logged in.
	 * @function
	 * @returns {undefined}
	 * @memberof Login
	 * @version 0.0.4
	 */
	created () {
		/* eslint-disable no-undef */
		const now = new Date().getTime()
		const activeBusiness = localStorage.getItem('activeBusiness')
		if (activeBusiness != null) {
			localStorage.removeItem('activeBusiness')
		}
		const sessionStart = localStorage.getItem('sessionStart')
		// If the session is not stored in localStorage then we are in the right place
		if (sessionStart != null) {
			// If the session has been running for less time than the session length + the modal timeout + a 2 second buffer than we need to refresh their token
			if (now - sessionStart < timer + timeoutCount + 2000) {
				let _this = this
				Auth.refresh().then(response => {
					_this.setV3Token(response)
					// If the token was successfully refreshed we can redirect them to the dashboard
					_this.$router.push('/app')
				}).catch(reason => {
					// If the token was not successfully refreshed we can clear localStorage and let them login again
					localStorage.removeItem('sessionStart')
				})
			} else {
				// Now we need to clear the session from localStorage
				App.methods.logOut()
			}
		}
	},
	/**
	 * Run on `mounted` to initialize the background rotator.
	 * @function
	 * @returns {undefined}
	 * @memberof Login
	 * @version 0.0.4
	 */
	mounted () {
		$('body').removeClass()

		let elm = $('.login-bg')
		let images = [
			img1,
			img2,
			img3
		]

		let options = {fade: 1000, duration: 6000}

		BackgroundRotator(elm, images, options).init()

		const sessionStart = localStorage.getItem('sessionStart')
		if (sessionStart == null) {
			// show mobile app modal if browsing on phone
			const userAgent = navigator.userAgent.toLowerCase()
			if (userAgent.indexOf('android') !== -1) {
				this.deviceType = 'Android'
				this.appStoreDetails.type = 'Google Play'
				this.appStoreDetails.url = 'http://play.google.com/store/apps/'
				this.showMobileAppPopup = true
			} else if (userAgent.indexOf('iphone') !== -1) {
				this.deviceType = 'iPhone'
				this.appStoreDetails.type = 'App Store'
				this.appStoreDetails.url = 'http://play.google.com/store/apps/'
				this.showMobileAppPopup = true
			} else if (userAgent.indexOf('ipad') !== -1) {
				this.deviceType = 'iPad'
				this.appStoreDetails.type = 'App Store'
				this.appStoreDetails.url = 'http://play.google.com/store/apps/'
				if (screen.availWidth <= 767) {
					this.showMobileAppPopup = true
				}
			}
		}

		window.addEventListener('resize', this.handleResize)
	},
	methods: {
		/**
		 * To hide the mobile app modal on window resize.
		 * @function
		 * @param {object} event - The resize event that prompted this function.
		 * @returns {undefined}
		 * @memberof Login
		 * @version 0.0.4
		 */
		handleResize (event) {
			if (this.showMobileAppPopup && screen.availWidth > 767) {
				this.showMobileAppPopup = false
			}
		},
		/**
		 * To show the forgot password form.
		 * @function
		 * @returns {undefined}
		 * @memberof Login
		 * @version 0.0.4
		 */
		showForgotPassword () {
			this.forgotPassword = true
			this.clearError()
		},
		/**
		 * To hide the forgot password form.
		 * @function
		 * @returns {undefined}
		 * @memberof Login
		 * @version 0.0.4
		 */
		goBack () {
			this.forgotPassword = false
			this.emailSent = false
			this.clearError()
		},
		/**
		 * To clear the current error.
		 * @function
		 * @returns {undefined}
		 * @memberof Login
		 * @version 0.0.4
		 */
		clearError () {
			this.errorMessage = ''
		},
		/**
		 * To check if the email and password are valid before submitting to the backend.
		 * @function
		 * @returns {object} A promise that will validate the input form
		 * @memberof Login
		 * @version 0.0.4
		 */
		validateLoginData () {
			let _this = this
			return new Promise((resolve, reject) => {
				if (!_this.user.email.length) {
					reject('Your email cannot be blank')
				} else if (!_this.user.password.length) {
					reject('Your password cannot be blank')
				} else if (!emailPattern.test(_this.user.email)) {
					reject('Please enter a valid email')
				} else if (_this.user.password.length < 8) {
					reject('Invalid credentials. Please check your email and password and try again.')
				}
				resolve('Hurray')
			})
		},
		/**
		 * To check if the email is valid before submitting to the backend for forgot password.
		 * @function
		 * @returns {object} A promise that will validate the email field
		 * @memberof Login
		 * @version 0.0.4
		 */
		validateEmail () {
			let _this = this
			return new Promise((resolve, reject) => {
				if (!_this.user.email.length) {
					reject('Your email cannot be blank')
				} else if (!emailPattern.test(_this.user.email)) {
					reject('Please enter a valid email')
				}
				resolve('Hurray')
			})
		},
		/**
		 * To prompt the backend call that logs the user in.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {object} A promise that will either return an error message or display the success screen
		 * @memberof Login
		 * @version 0.0.4
		 */
		login (event) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			this.clearError()
			return _this.validateLoginData()
			.then(response => {
				Auth.login(_this.user.email, _this.user.password).then(response => {
					// If the login attempt is successful then clear the localStorage (because it will be reset when it reaches the app) and route to the app
					/* eslint-disable no-undef */
					localStorage.clear()
					_this.clearVuexStore()
					_this.$router.push('/app')
					disabledButton.complete()
				}).catch(_this.$root.errorWrapper(e => {
					// If the login attempt fails then display the error message
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
						case 'no_matching_user':
							_this.errorMessage = 'Invalid credentials. Please check your email and password and try again.'
							break

						case 'invalid_input':
							if (e.responseJSON.payload.email) {
								_this.errorMessage = 'Your email must be a valid email.'
							}
							break

						default:
							// No default
						}
					}
					disabledButton.cancel()
				}))
			}).catch(reason => {
				// If validation fails then display the error message
				_this.errorMessage = reason
				disabledButton.cancel()
			})
		},
		/**
		 * To prompt the backend call that submits the forgot password form.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {object} A promise that will either return an error message or display the success screen
		 * @memberof Login
		 * @version 0.0.4
		 */
		submitForgotPassword (event) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			return _this.validateEmail()
			.then(response => {
				Auth.forgotPassword(_this.user.email).then(response => {
					// If the backend call is successful then display the success screen.
					_this.emailSent = true
					disabledButton.complete()
				}).catch(_this.$root.errorWrapper(e => {
					// If the backend call fails then display the error message
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
						case 'email_failed':
							_this.errorMessage = 'Unable to send email. Please check your email address and try again.'
							break

						default:
							// No default
						}
					}
					disabledButton.cancel()
				}))
			}).catch(reason => {
				// If validation fails then display the error message
				_this.errorMessage = reason
				disabledButton.cancel()
			})
		},
		...mapActions([
			'clearVuexStore',
			'setV3Token'
		])
	},
	components: {
		Modal
	}
}
</script>

<style>
	.login-bg {
  		background-image: url('~src/assets/img/app/login/bg1.jpg');
	}
	.user-login-5 .alert-email-error {
		margin-top: 0px;
	}
	.user-login-5 .forget-form .alert {
		margin-top: 0px;
	}
</style>


// WEBPACK FOOTER //
// Login.vue?4b77462e